// Etiquetas que no salen bien de la conversión automática del valor crudo.
const ETIQUETAS = {
  EN_RENEGOCIACION: "En negociación",
};

/**
 * Convierte el valor crudo de un estado de propuesta (V1 o V2) en una
 * etiqueta legible. Consulta primero la tabla de excepciones para los
 * estados cuya conversión automática queda mal escrita (tildes, palabras
 * que no corresponden) y cae al formateo por guion bajo para el resto.
 * Toda pantalla que muestre el mismo estado debe pasar por esta función:
 * si cada una arma su propia conversión, la misma propuesta termina con
 * una etiqueta distinta según la vista.
 */
export const formatEstadoPropuesta = (estado) =>
  ETIQUETAS[estado] ??
  estado
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
